import { isNil } from 'lodash'

import { SchemaItem } from '@eastcoal/formily/components/SchemaForm/interface'
import { DataField } from '@eastcoal/formily/exports/core'

export const quotaValue1Validator: SchemaItem['x-validator'] = {
  required: true,
  validator(_, __, ctx) {
    const parentField = ctx.field.parent as DataField
    const { value2, value1 } = parentField.value
    if (isNil(value1)) {
      return '最小值不能为空'
    }

    if (value1 <= 0) {
      return '最小值不能小于等于0'
    }

    if (!isNil(value2) && value1 > value2) {
      return '最小值不能大于最大值'
    }

    return null
  }
}
